"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CarouselSlides = _interopRequireDefault(require("./CarouselSlides"));

var _CarouselPaginator = _interopRequireDefault(require("./CarouselPaginator"));

var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Carousel, _PureComponent);

  function Carousel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Carousel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Carousel).call(this, props)); // TODO: slide changes cause a very quick flicker when clicking on pagination for non-subsequent pages on initial load

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onPageClick", function (index) {
      _this._goToIndex(index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onPrevious", function () {
      _this._goToIndex(_this.state.currentIndex - 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onNext", function () {
      _this._goToIndex(_this.state.currentIndex + 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_clearSlideShownTimeout", function () {
      if (_this._slideShownTimeout) {
        clearTimeout(_this._slideShownTimeout);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_goToIndex", function (index) {
      if (_this._isTransitioning) {
        return;
      }

      if (_this.props.transition !== 'none') {
        _this._isTransitioning = true;
      }

      var newIndex;

      if (index < 0) {
        newIndex = _this._totalSlides - 1;
      } else if (index > _this._totalSlides - 1) {
        newIndex = 0;
      } else {
        newIndex = index;
      }

      _this.setState({
        currentIndex: newIndex
      });
    });
    _this._TRANSITION_TIME = 250;
    _this._isTransitioning = false;
    _this.state = {
      currentIndex: props.startIndex
    };
    return _this;
  }

  (0, _createClass2.default)(Carousel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          onBeforeSlideShown = _this$props.onBeforeSlideShown,
          onAfterSlideShown = _this$props.onAfterSlideShown;
      var currentIndex = this.state.currentIndex;
      var previousIndex = prevState.currentIndex;

      if (previousIndex !== currentIndex) {
        this._clearSlideShownTimeout();

        if (onBeforeSlideShown) {
          onBeforeSlideShown(currentIndex, previousIndex);
        }

        this._slideShownTimeout = (0, _setTimeout2.default)(function () {
          _this2._isTransitioning = false;

          if (onAfterSlideShown) {
            onAfterSlideShown(currentIndex, previousIndex);
          }
        }, this._TRANSITION_TIME);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._clearSlideShownTimeout();
    }
  }, {
    key: "_renderSlides",
    value: function _renderSlides(slides) {
      this._totalSlides = slides.props.children.length;
      var _this$props2 = this.props,
          showArrows = _this$props2.showArrows,
          showDots = _this$props2.showDots,
          showPageNumbers = _this$props2.showPageNumbers,
          lazyLoad = _this$props2.lazyLoad,
          preload = _this$props2.preload;
      var internalShowArrows = this._totalSlides > 1 ? showArrows : false;
      return (0, _react.cloneElement)(slides, {
        currentIndex: this.state.currentIndex,
        showArrows: internalShowArrows,
        showDots: showDots,
        showPageNumbers: showPageNumbers,
        lazyLoad: lazyLoad,
        preload: preload,
        onPreviousClick: this._onPrevious,
        onNextClick: this._onNext,
        onDotClick: this._goToIndex
      });
    }
  }, {
    key: "_renderPagination",
    value: function _renderPagination(items) {
      if (items.length < 2) {
        return null;
      }

      return (0, _react.cloneElement)(items, {
        onItemClick: this._onPageClick,
        currentIndex: this.state.currentIndex
      });
    }
  }, {
    key: "_renderChildren",
    value: function _renderChildren() {
      var _this3 = this;

      return (0, _map.default)(_react.Children).call(_react.Children, this.props.children, function (child) {
        if (child && child.type && (child.type === _CarouselSlides.default || child.type.displayName === 'CarouselSlides')) {
          return _this3._renderSlides(child);
        } else if (child && child.type && (child.type === _CarouselPaginator.default || child.type.displayName === 'CarouselPaginator')) {
          return _this3._renderPagination(child);
        } else {
          return null;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          transition = _this$props3.transition;
      var classes = (0, _classnames.default)('Carousel', "Carousel-transition-".concat(transition), className);
      return _react.default.createElement("div", {
        className: classes
      }, this._renderChildren());
    }
  }]);
  return Carousel;
}(_react.PureComponent);

exports.default = Carousel;
(0, _defineProperty2.default)(Carousel, "defaultProps", {
  showArrows: true,
  preload: true,
  lazyLoad: true,
  transition: 'none',
  startIndex: 0
});